var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "SBbetSlip",
      class: [_vm.currentBetSlipStateName],
      attrs: { id: "SBbetSlip" }
    },
    [
      _c(
        "div",
        { staticClass: "bets" },
        [
          _c("bet-slip-tabs", {
            attrs: {
              tab: _vm.tab,
              currentBetSlipState: _vm.currentBetSlipState,
              betsNo: _vm.betsNo,
              allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns,
              betTypeStakes: _vm.betTypeStakes,
              gettingABTnR: _vm.gettingABTnR,
              interRelated: _vm.interRelated,
              allowedMultiSingles: _vm.allowedMultiSingles,
              betSlipStatus: _vm.betSlipStatus
            }
          }),
          _vm._v(" "),
          !_vm.betsNo
            ? _c("div", { staticClass: "emptyBetSlip" }, [
                _vm.brandLayout !== "generic" &&
                _vm.brandKey !== "sb" &&
                _vm.brandKey !== "qcasino"
                  ? _c(
                      "div",
                      { staticClass: "add-bets-container" },
                      [
                        _c("v-icon", [_vm._v("add")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ab-info-msg" }, [
                          _c("span", { staticClass: "ab-label" }, [
                            _vm._v(_vm._s(_vm.$t("BetSlip.add.bets")))
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "ab-label zerobets",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("BetSlip.zero.bets"))
                            }
                          })
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.brandLayout === "generic"
                  ? _c("div", { staticClass: "empty-betslip-container" }, [
                      _c("img", {
                        staticClass: "empty_betslip",
                        attrs: {
                          src: _vm.mediaServer(
                            "/static/brand-img/" +
                              _vm.brandKey +
                              "/empty-betslip.svg"
                          ),
                          alt: "Betslip"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.brandKey === "sb"
                  ? _c("div", { staticClass: "empty-betslip-container" }, [
                      _c("span", { staticClass: "empty-betslip-label" }, [
                        _vm._v(_vm._s(_vm.$t("BetSlip.emptyBetslip")))
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "empty_betslip",
                        attrs: {
                          src: _vm.mediaServer(
                            "/static/brand-img/" +
                              _vm.brandKey +
                              "/empty-betslip_" +
                              _vm.state +
                              ".svg"
                          ),
                          alt: "Betslip"
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.brandKey === "qcasino"
                  ? _c("div", { staticClass: "empty-betslip-container" }, [
                      _c("span", { staticClass: "empty-betslip-label" }, [
                        _vm._v(_vm._s(_vm.$t("BetSlip.emptyBetslip")))
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "empty_betslip",
                        attrs: {
                          src: require("@/assets/images/brands/qcasino/empty-betslip.svg"),
                          alt: "Betslip"
                        }
                      })
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "fixed_footer_sep",
        class: { bet_placed: _vm.betSlipStatus.State == 2 },
        style: _vm.betslipActionsHeight
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "betActions",
          staticClass: "betslip_actions",
          class: { bet_placed: _vm.betSlipStatus.State == 2 }
        },
        [
          _vm.brandLayout === "generic" && _vm.betslipLayout2
            ? [
                _c("tabs-betslip-bottom", {
                  attrs: {
                    tab: _vm.tab,
                    currentBetSlipState: _vm.currentBetSlipState,
                    betsNo: _vm.betsNo,
                    betTypeStakes: _vm.betTypeStakes,
                    allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("bet-slip-msgs", {
            staticClass: "BetSlipMsgs",
            attrs: {
              tab: _vm.tab,
              currentBetSlipState: _vm.currentBetSlipState,
              isLoggedIn: _vm.isLoggedIn,
              betsNo: _vm.betsNo,
              betPlacementResult: _vm.betPlacementResult,
              betSlipStatus: _vm.betSlipStatus,
              inRefferal: _vm.inRefferal,
              inRunningDelay: _vm.inRunningDelay,
              gracePeriod: _vm.gracePeriod,
              mobileBigAndBelow: _vm.mobileBigAndBelow,
              promotionsData: _vm.promotionsData,
              state: _vm.$t("App.State.Name." + _vm.STATE),
              betSlipTotals: _vm.betSlipTotals
            },
            on: { setTabFromBetSlip: _vm.setTabFromBetSlip }
          }),
          _vm._v(" "),
          _c("bet-slip-btns", {
            staticClass: "BetSlipBtns",
            attrs: {
              tab: _vm.tab,
              currentBetSlipState: _vm.currentBetSlipState,
              isLoggedIn: _vm.isLoggedIn,
              betsNo: _vm.betsNo,
              betSlipTotals: _vm.betSlipTotals,
              gettingABTnR: _vm.gettingABTnR,
              betPlacementResult: _vm.betPlacementResult,
              betSlipStatus: _vm.betSlipStatus,
              inRefferal: _vm.inRefferal,
              betSlipChangeNo: _vm.betSlipChangeNo,
              mobileBigAndBelow: _vm.mobileBigAndBelow,
              isGeoLocationEnabled: _vm.isGeoLocationEnabled,
              promotionsData: _vm.promotionsData
            },
            on: { setTabFromBetSlip: _vm.setTabFromBetSlip }
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.mobileBigAndBelow
        ? _c(
            "v-dialog",
            {
              attrs: {
                "content-class": "dialog-single-bet-slip",
                persistent: "",
                allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturns,
                "hide-overlay": true,
                fullscreen: false,
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialogSingleBetslip.active,
                callback: function($$v) {
                  _vm.$set(_vm.dialogSingleBetslip, "active", $$v)
                },
                expression: "dialogSingleBetslip.active"
              }
            },
            [
              _vm.brandTemplate === "generic_2"
                ? _c("div", { staticClass: "fastBetslipHeader" }, [
                    _vm._v(_vm._s(_vm.$t("BottomNav.FastBet")))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("fast-bet-slip", {
                attrs: {
                  dialogSingleBetslip: _vm.dialogSingleBetslip,
                  state: _vm.$t("App.State.Name." + _vm.STATE)
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-709e42ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709e42ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/betslip.vue
// module id = null
// module chunks = 